module.exports = __webpack_public_path__ + "static/img/notfound.d0b54231.png";